/**
 * @class Claim
 * 취소/환불 탭 내용
 */
export default class Claim {
  constructor() {
    this.sWrapper = '_claimDescription';
    this.welWrapper = $('#_claimDescription');

    if (TMON.oApp.sPlatform === 'PW') {
      this.renderPc();
    } else {
      this.renderMobile();
    }
    this.setEvent();
  }

  setEvent() {
    // toggle eventListener 등록
    this.welWrapper.on('click', '[data-role=toggleButton]', this.onClickToggle);
    // 환불/교환 신청
    this.welWrapper.on('click', '.btn_go', this.onClickClaimBtn);
  }

  /**
   * toggle eventListener
   */
  onClickToggle = e => {
    $(e.currentTarget).toggleClass('open');
  };

  onClickClaimBtn = e => {
    e.preventDefault();
    if (!TMON.bLogin && TMON.oApp.sPlatform !== 'MA') {
      TMON.oApp.oUtil.login(TMON.htLocal.htURL.my_buyHistory);
    } else {
      window.location.href = `${TMON.htLocal.htURL.my_buyHistory}?type=delivery`;
    }
  }

  makePcRefundText = deliveryInfo => {
    const basicTxt =
      '<td>반품배송비는 제품하자 및 오배송인 경우 판매자 부담, 단순변심인 경우 반품배송비를 차감 후 환불됩니다. (무료배송, 조건부 무료배송인 경우 최초배송비 + 반품배송비가 차감됩니다.) 단, 도서/산간 지역 및 설치/해외 배송 상품은 기본 배송비 외 추가 배송비가 발생할 수 있습니다.</td>';
    if (!deliveryInfo) {
      return basicTxt;
    }
    // - FREE(무료배송), PER(선결제), CONDITION(조건부 무료배송), AFTER(착불), NONE(NONE)
    switch (deliveryInfo.deliveryFeePolicy) {
      case 'FREE':
        return `<td>
                            <dl class="lst_dfn">
                            <dt>왕복 ${TMON.util.numberFormat(
                              deliveryInfo.deliveryFee * 2
                            )}원</dt>
                                <dd>
                                    <ul>
                                        <li>고객 단순 변심의 경우에만 발생되며, 최초 배송비 무료인 경우 왕복배송비 차감 후 환불됩니다.</li>
                                        <li>도서 산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                                    </ul>
                                </dd>
                            </dl>
                        </td>`;
      case 'PER':
        return `<td>
                            <dl class="lst_dfn">
                            <dt>편도 ${TMON.util.numberFormat(
                              deliveryInfo.deliveryFee
                            )}원</dt>
                                <dd>
                                    <ul>
                                        <li>고객 단순 변심의 경우에만 발생되며, 반품배송비 차감 후 환불됩니다.</li>
                                        <li>도서 산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                                    </ul>
                                </dd>
                            </dl>
                        </td>`;
      case 'AFTER':
        return `<td>
                            <dl class="lst_dfn">
                            <dt>환불/교환 반품배송비는 상품 상세페이지 참고</dt>
                                <dd>
                                    <ul>
                                        <li>단순 변심의 경우에는 고객님께서 택배비를 부담해주셔야 합니다.</li>
                                        <li>도서 산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                                    </ul>
                                </dd>
                            </dl>
                        </td>`;
      case 'CONDITION':
        return `<td>
                            <dl class="lst_dfn">
                            <dt>편도 ${TMON.util.numberFormat(
                              deliveryInfo.deliveryFee
                            )}원/ 왕복 ${TMON.util.numberFormat(
          deliveryInfo.deliveryFee * 2
        )}원</dt>
                                <dd>
                                    <ul>
                                        <li>고객 단순 변심의 경우에만 발생되며, 최초 배송비 무료인 경우 왕복배송비 차감 후 환불됩니다.</li>
                                        <li>단, 부분반품 시 남은 금액이 무료배송 조건 유지하면 편도비용 부과됩니다.</li>
                                        <li>도서산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                                    </ul>
                                </dd>
                            </dl>
                        </td>`;
      default:
        return basicTxt;
    }
  };

  makePcExchangeText = deliveryInfo => {
    const basicTxt =
      '<td>제품하자 및 오배송인경우 판매자 부담이며, 단순 변심인 경우 왕복 배송비를 확인 후 박스에 동봉해서 보내주시면 됩니다. 일반적으로 5,000원이지만 상품에 따라 상이하며, 재고가 없는 경우 환불 처리될 수 있습니다.</td>';
    if (!deliveryInfo) {
      return basicTxt;
    }
    // - FREE(무료배송), PER(선결제), CONDITION(조건부 무료배송), AFTER(착불), NONE(NONE)
    switch (deliveryInfo.deliveryFeePolicy) {
      case 'FREE':
      case 'PER':
      case 'CONDITION':
        return `<td>
                            <dl class="lst_dfn">
                            <dt>${TMON.util.numberFormat(
                              deliveryInfo.deliveryFee * 2
                            )}원</dt>
                                <dd>
                                    <ul>
                                        <li>동일상품 및 동일 옵션으로만 교환이 가능하며, 판매자귀책(제품하자, 오배송 등)으로 요청하셨더라도 상품확인 결과에 따라 배송비 입금을 요청드릴 수 있습니다.</li>
                                        <li>도서 산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                                    </ul>
                                </dd>
                            </dl>
                        </td>`;
      case 'AFTER':
        return `<td>
                            <dl class="lst_dfn">
                            <dt>환불/교환 반품배송비는 상품 상세페이지 참고</dt>
                                <dd>
                                    <ul>
                                        <li>단순 변심의 경우에는 고객님께서 택배비를 부담해주셔야 합니다.</li>
                                        <li>도서 산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                                    </ul>
                                </dd>
                            </dl>
                        </td>`;
      default:
        return basicTxt;
    }
  };

  makeMobileRefundText = deliveryInfo => {
    const basicTxt =
      '<dd>반품배송비는 제품하자 및 오배송인 경우 판매자 부담, 단순변심인 경우 반품배송비를 차감 후 환불됩니다. (무료배송, 조건부 무료배송인 경우 최초배송비 + 반품배송비가 차감됩니다.) 단, 도서/산간 지역 및 설치/해외 배송 상품은 기본 배송비 외 추가 배송비가 발생할 수 있습니다.</dd>';
    if (!deliveryInfo || !TMON.oApp.htStorage.htStaticData.bIsDeliveryDeal) {
      return basicTxt;
    }
    // - FREE(무료배송), PER(선결제), CONDITION(조건부 무료배송), AFTER(착불), NONE(NONE)
    switch (deliveryInfo.deliveryFeePolicy) {
      case 'FREE':
        return `<dd>
                            <strong class="lst_title">왕복 ${TMON.util.numberFormat(
                              deliveryInfo.deliveryFee * 2
                            )}원</strong>
                            <ul>
                                <li>고객 단순 변심의 경우에만 발생되며, 최초 배송비 무료인 경우 왕복배송비 차감 후 환불됩니다.</li>
                                <li>도서산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                            </ul>
                        </dd>`;
      case 'PER':
        return `<dd>
                            <strong class="lst_title">편도 ${TMON.util.numberFormat(
                              deliveryInfo.deliveryFee
                            )}원</strong>
                            <ul>
                                <li>고객 단순 변심의 경우에만 발생되며, 반품배송비 차감 후 환불됩니다.</li>
                                <li>도서 산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                            </ul>
                        </dd>`;
      case 'AFTER':
        return `<dd>
                            <strong class="lst_title">환불/교환 반품배송비는 상품 상세페이지 참고</strong>
                            <ul>
                                <li>단순 변심의 경우에는 고객님께서 택배비를 부담해주셔야 합니다.</li>
                                <li>도서 산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                            </ul>
                        </dd>`;
      case 'CONDITION':
        return `<dd>
                            <strong class="lst_title">편도 ${TMON.util.numberFormat(
                              deliveryInfo.deliveryFee
                            )}원/ 왕복 ${TMON.util.numberFormat(
          deliveryInfo.deliveryFee * 2
        )}원</strong>
                            <ul>
                                <li>고객 단순 변심의 경우에만 발생되며, 최초 배송비 무료인 경우 왕복배송비 차감 후 환불됩니다.</li>
                                <li>단, 부분반품 시 남은 금액이 무료배송 조건 유지하면 편도비용 부과됩니다.</li>
                                <li>도서산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                            </ul>
                        </dd>`;
      default:
        return basicTxt;
    }
  };

  makeMobileExchangeText = deliveryInfo => {
    const basicTxt =
      '<dd>제품하자 및 오배송인경우 판매자 부담이며, 단순 변심인 경우 왕복 배송비를 확인 후 박스에 동봉해서 보내주시면 됩니다. 일반적으로 5,000원이지만 상품에 따라 상이하며, 재고가 없는 경우 환불 처리될 수 있습니다.</dd>';
    if (!deliveryInfo || !TMON.oApp.htStorage.htStaticData.bIsDeliveryDeal) {
      return basicTxt;
    }
    // - FREE(무료배송), PER(선결제), CONDITION(조건부 무료배송), AFTER(착불), NONE(NONE)
    switch (deliveryInfo.deliveryFeePolicy) {
      case 'FREE':
      case 'PER':
      case 'CONDITION':
        return `<dd>
                            <strong class="lst_title">${TMON.util.numberFormat(
                              deliveryInfo.deliveryFee * 2
                            )}원</strong>
                            <ul>
                                <li>동일상품 및 동일 옵션으로만 교환이 가능하며, 판매자귀책(제품하자, 오배송 등)으로 요청하셨더라도 상품확인 결과에 따라 배송비 입금을 요청드릴 수 있습니다.</li>
                                <li>도서 산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                            </ul>
                        </dd>`;
      case 'AFTER':
        return `<dd>
                            <strong class="lst_title">환불/교환 반품배송비는 상품 상세페이지 참고</strong>
                            <ul>
                                <li>단순 변심의 경우에는 고객님께서 택배비를 부담해주셔야 합니다.</li>
                                <li>도서 산간 지역 및 설치/해외 배송 상품은 추가 비용이 발생할 수 있습니다.</li>
                            </ul>
                        </dd>`;
      default:
        return basicTxt;
    }
  };

  renderPc() {
    const { bIsDeliveryDeal } = TMON.oApp.htStorage.htStaticData;
    if (!bIsDeliveryDeal) {
      return; // 배송딜이 아닐 경우에는 아래 내용을 전부 노출하지 않는다.
    }
    const { deliveryInfo } = TMON.oApp.htStorage.htStaticData.htDealInfo;
    const sHtml = `
            <div class="bx_ct">
                <div class="ct_wrp">
                    <div class="prmt_area">
                        <h4 class="tit">지금 바로 마이티몬에서 클릭 한 번으로 간편하게 <strong>환불/교환을 신청</strong> 할 수 있습니다.</h4>
                        <a href="#" class="btn_go" data-tlarea="PCRP" data-tlord="1">환불/교환 신청</a>
                    </div>
                </div>
            </div>
            <div class="bx_ct ct_period">
                <div class="ct_wrp">
                    <h4>환불/교환 가능 기간</h4>
                    <div class="ct">
                        <dl class="lst_dfn">
                            <dt>환불/교환 요청은 <strong>배송 완료 시점으로부터 7일 이내</strong>에 가능합니다.</dt>
                            <dd>(단, 수령한 상품이 표기 광고의 내용과 다르거나 계약 내용과 다르게 이행된 경우에는 수령한 날로부터 3개월 이내, 그 사실을 알 수 있었던 날로부터 30일 이내에는 환불/교환 신청 가능합니다.)</dd>
                        </dl>
                    </div>
                </div>
            </div>
            <div class="bx_ct">
                <div class="ct_wrp">
                    <h4>환불/교환 요청 방법</h4>
                    <div class="ct">
                        <table class="tbl_info tbl_req">
                            <caption>환불/교환 요청 방법</caption>
                            <colgroup>
                                <col width="192">
                                <col width="*">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th scope="row">
                                        <span class="ic_ref">환불</span>
                                    </th>
                                    <td>
                                        <ol class="lst_order">
                                            <li><em>마이티몬 &gt; 구매내역 페이지에서 환불 요청</em></li>
                                            <li>
                                            <em>택배기사 반품 상품 수거(일부 화불/설치 상품 제외) OR 편의점에서 반품 접수</em>
                                                <ul>
                                                    <li>택배반품:환불 요청 후 1~3일 이내(주말/공휴일 제외)에 지정 택배사 직원 또는 해당 판매업체에서 직접 수거합니다.</li>
                                                    <li>편의점반품:가까운 편의점 (CU, GS25)에 방문하셔서 직접 접수해주세요.</li>
                                                </ul>
                                            </li>
                                            <li><em>환불완료</em></li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">
                                        <span class="ic_exc">교환</span>
                                    </th>
                                    <td>
                                        <ol class="lst_order">
                                            <li><em>마이티몬 &gt; 구매내역 페이지에서 교환 요청</em></li>
                                            <li>
                                            <em>택배기사 반품 상품 수거(일부 화불/설치 상품 제외) OR 편의점에서 반품 접수</em>
                                                <ul>
                                                    <li>택배반품:환불 요청 후 1~3일 이내(주말/공휴일 제외)에 지정 택배사 직원 또는 해당 판매업체에서 직접 수거합니다.</li>
                                                    <li>편의점반품:가까운 편의점 (CU, GS25)에 방문하셔서 직접 접수해주세요.</li>
                                                </ul>
                                            </li>
                                            <li><em>새제품 재배송</em></li>
                                        </ol>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="txt_bot_notice">환불/교환 관련하여 더 궁금하신 점은 고객센터 &gt; 자주묻는 질문에서 확인 가능합니다.<a href="${
                          TMON.htLocal.htURL.help_faq
                        }" target="_blank" class="btn_ex_link">자주 묻는 질문 바로가기</a></div>
                    </div>
                </div>
            </div>
            <div class="bx_ct">
                <div class="ct_wrp">
                    <h4>반품 배송비</h4>
                    <div class="ct">
                        <table class="tbl_info">
                            <caption>반품 배송비</caption>
                            <colgroup>
                                <col width="192">
                                <col width="*">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th scope="row">환불시</th>
                                    ${this.makePcRefundText(deliveryInfo)}
                                </tr>
                                <tr>
                                    <th scope="row">교환시</th>
                                    ${this.makePcExchangeText(deliveryInfo)}
                                </tr>
                            </tbody>
                        </table>
                        <div class="txt_bot_notice">
                            <ul>
                                <li>· 구매시점에 따라 적용되는 반품배송비가 다를 수 있으며, 구매 당시의 배송비가 적용됩니다.</li>
                                <li>· 마이티몬 &gt; 구매내역 &gt; 배송비에서 구매 당시의 배송비 정보 확인이 가능합니다.</li>
                                <li>· 냉장/냉동/신선, 주문제작, 화물/설치 상품들은 단순변심에 의한 환불이 불가할 수 있으며, 자세한 내용은 상품설명 페이지에서 확인 가능합니다.</li>
                                <li>· 여러 개의 박스로 나누어 발송된 경우 박스당 반품 배송비가 부과됩니다.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bx_ct ct_mypage">
                <div class="ct_wrp">
                    <h4>마이티몬 요청 가능 기능 안내</h4>
                    <div class="ct">
                        <table class="tbl_info_type_02">
                            <caption>마이티몬 요청 가능 기능 안내</caption>
                            <colgroup>
                                <col width="17%">
                                <col width="17%">
                                <col width="16%">
                                <col width="50%">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col">배송 상태</th>
                                    <th scope="col">상태 설명</th>
                                    <th scope="col">요청 가능 기능</th>
                                    <th scope="col">요청 및 처리 방법</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="ta_c">결제완료</td>
                                    <td class="ta_c">판매자<br />주문 확인 전</td>
                                    <td class="ta_c"><strong>구매취소</strong></td>
                                    <td>
                                        <dl class="lst_dfn">
                                            <dt>[구매취소] 버튼 클릭 시 즉시 환불 처리</dt>
                                            <dd>결제 방법에 따라 환불 시점에 차이가 있을 수 있습니다.</dd>
                                        </dl>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="ta_c">상품준비중</td>
                                    <td class="ta_c">판매자 주문 확인<br />및 상품 준비</td>
                                    <td class="ta_c"><strong>취소요청</strong></td>
                                    <td>
                                        <dl class="lst_dfn">
                                            <dt>[취소요청] 등록 후, 판매자 확인 후 승인(즉시 환불) 또는 철회</dt>
                                            <dd>결제 방법에 따라 환불 시점에 차이가 있을 수 있습니다.</dd>
                                        </dl>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="ta_c">배송준비중</td>
                                    <td class="ta_c">상품 포장 및<br />송장 등록 완료</td>
                                    <td class="ta_c" rowspan="2"><strong>환불요청</strong></td>
                                    <td rowspan="2">
                                        <dl class="lst_dfn">
                                            <dt>상품 수령 전</dt>
                                            <dd>
                                                <ul>
                                                    <li>[환불요청] 등록 후, 택배기사님께 수취거부 의사를 밝혀 주세요.</li>
                                                    <li>판매자가 반품 확인 후 승인(즉시환불)해 드립니다.</li>
                                                </ul>
                                            </dd>
                                        </dl>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="ta_c">배송중</td>
                                    <td class="ta_c">상품 배송 중</td>
                                </tr>
                                <tr>
                                    <td class="ta_c" rowspan="2">배송완료</td>
                                    <td class="ta_c" rowspan="2">상품 배송 완료</td>
                                    <td class="ta_c"><strong>환불요청</strong></td>
                                    <td>
                                        <dl class="lst_dfn">
                                            <dt>상품 수령 후</dt>
                                            <dd>
                                                <ul>
                                                    <li>[환불요청] 등록 후, 1~3일 내에 택배기사님이 반품을 수거하니, 잠시만 기다려주세요.<br />※ 다른 택배사를 통해 반품하신 경우 운송장 번호를 꼭 등록해 주세요.</li>
                                                    <li>반품 상품 검수 후 환불해 드립니다.(영업일 기준 최대 7일 소요)</li>
                                                </ul>
                                            </dd>
                                        </dl>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="ta_c"><strong>교환요청</strong></td>
                                    <td>
                                        <dl class="lst_dfn">
                                            <dt>상품 받으신 후</dt>
                                            <dd>[교환요청] 등록 후, 환불과 동일하게 반품하시면 <br />판매자가 확인 후 새제품으로 교환</dd>
                                        </dl>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="txt_bot_notice">위 내용은 모두 마이티몬 &gt; 구매내역에서 요청 및 처리 가능합니다.<a href="${
                          TMON.htLocal.htURL.my_buyHistory
                        }?type=delivery" target="_blank" class="btn_ex_link">배송상품 구매내역 바로가기</a></div>
                    </div>
                </div>
            </div>
            <div class="bx_ct">
                <div class="ct_wrp">
                    <h4>환불/교환 가능 안내</h4>
                    <div class="ct">
                        <table class="tbl_info">
                            <caption>환불/교환 가능 안내</caption>
                            <colgroup>
                                <col width="192">
                                <col width="*">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th scope="row">상태 별 환불/교환 <br />불가 사유</th>
                                    <td>
                                        <ul class="lst_dot">
                                            <li>환불/교환 요청 가능 기간이 초과한 경우(배송 완료 시점으로부터 7일 초과 시)</li>
                                            <li>재고가 부족한 경우(단순 변심으로 교환을 요청했으나 재고가 부족한 경우 환불처리될 수 있음)</li>
                                            <li>주문/제작 상품의 제작이 이미 진행된 경우</li>
                                            <li>분실/파손/고장/오염이 발생한 경우</li>
                                            <li>모니터 해상도 차이로 인하여 색상 등 이미지가 실제와 상이한 경우</li>
                                            <li>뷰티 상품 이용 시 트러블이 발생하는 경우(진료 확인서 및 소견서 등 증빙 시 환불가능. 이 경우, 제반 비용은 고객님께서 부담)</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">상품군 별 환불/교환 <br />불가 사유</th>
                                    <td>
                                        <ul class="lst_dot">
                                            <li>
                                                <em>가전/설치상품</em>
                                                소비자에게 책임이 있는 사유로 재화 등이 멸실되거나 훼손된 경우 (단, 재화 등의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)
                                            </li>
                                            <li>
                                                <em>의류/잡화/수입명품</em>
                                                구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우
                                            </li>
                                            <li>
                                                <em>식품/계절상품/화장품</em>
                                                시간의 경과로 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우
                                            </li>
                                            <li>
                                                <em>CD/DVD/GAME/BOOK 등</em>
                                                복제가 가능한 상품 등의 포장을 개봉/훼손한 경우
                                            </li>
                                            <li>
                                                <em>네비게이션/OS 등</em>
                                                상품의 고유 시리얼 넘버가 훼손/유출되어 내장된 소프트웨어의 가치가 감소한 경우
                                            </li>
                                            <li>
                                                <em>노트북/데스크탑 PC 등</em>
                                                홀로그램 등이 분리/분실/훼손되어 상품의 가치가 현저히 감소하여 재판매가 불가할 경우
                                            </li>
                                            <li>
                                                <em>블랙박스/후방카메라/에어컨 등</em>
                                                상품을 개봉하여 설치/장착한 경우
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="txt_bot_notice">정당한 사유로 반품 요청을 하였으나 판매자와 협의가 되지 않는 경우, 티몬 모바일 앱 [마이티몬>고객센터] 내 1:1채팅상담으로 문의 부탁 드립니다.</div>
                    </div>
                </div>
            </div>`;
    $(`#${this.sWrapper}`).html(sHtml);
  }

  renderMobile() {
    const { bIsDeliveryDeal } = TMON.oApp.htStorage.htStaticData;
    if (!bIsDeliveryDeal) {
      return; // 배송딜이 아닐 경우에는 아래 내용을 전부 노출하지 않는다.
    }

    const { deliveryInfo } = TMON.oApp.htStorage.htStaticData.htDealInfo;
    const sHtml = `<div class="bx_ct">
                <div class="ct_wrp">
                  <button type="button" data-role="toggleButton" class="toggle tit_align_top open">
                    <h4>환불/교환 가능 기간</h4>
                  </button>
                  <div class="ct slide-ct">
                    <dl class="lst_dfn">
                      <dt>환불/교환 요청은 <strong>배송 완료 시점으로부터 7일 이내</strong>에 가능합니다.</dt>
                      <dd>(단, 수령한 상품이 표기 광고의 내용과 다르거나 계약 내용과 다르게 이행된 경우에는 수령한 날로부터 3개월 이내, 그 사실을 알 수 있었던 날로부터 30일 이내에는 환불/교환 신청 가능합니다.)</dd>
                    </dl>  
                  </div>
                </div>
            </div>
            <div class="bx_ct">
              <div class="ct_wrp">
                <button type="button" data-role="toggleButton" class="toggle tit_align_top open">
                  <h4>환불/교환 요청 방법</h4>
                </button>
                <div class="ct slide-ct">
                  <ol class="lst_order">
                    <li><em>마이티몬 &gt; 구매내역 페이지에서 환불/교환 요청</em></li>
                    <li>
                      <em>택배기사 반품 상품 수거(일부 화불/설치 상품 제외) OR 편의점에서 반품 접수</em>
                      <ul>
                        <li>택배반품:환불 요청 후 1~3일 이내(주말/공휴일 제외)에 지정 택배사 직원 또는 해당 판매업체에서 직접 수거합니다.</li>
                        <li>편의점반품 : 가까운 편의점 (CU, GS25)에 방문하셔서 직접 접수해주세요.</li>
                      </ul>
                    </li>
                    <li><em>환불완료</em></li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="bx_ct">
              <div class="ct_wrp">
                <button type="button" data-role="toggleButton" class="toggle tit_align_top open">
                  <h4>반품배송비</h4>
                </button>
                <div class="ct slide-ct">
                  <dl class="lst_dfn">
                    <dt class="blind">반품배송비 안내</dt>
                    <dd>
                        <ul>
                            <li class="lst_style_none">- 구매시점에 따라 적용되는 반품배송비가 다를 수 있으며, 구매 당시의 배송비가 적용됩니다.</li>
                            <li class="lst_style_none">- 마이티몬 &gt; 구매내역 &gt; 배송비에서 구매 당시의 배송비 정보 확인이 가능합니다.</li>
                            <li class="lst_style_none">- 냉장/냉동/신선, 주문제작, 화물/설치 상품들은 단순변심에 의한 환불이 불가할 수 있으며, 자세한 내용은 상품설명 페이지에서 확인 가능합니다.</li>
                            <li class="lst_style_none">- 여러 개의 박스로 나누어 발송된 경우 박스당 반품 배송비가 부과됩니다.</li>
                        </ul>
                    </dd>
                    <dt>환불시</dt>
                    ${this.makeMobileRefundText(deliveryInfo)}
                    <dt>교환시</dt>
                    ${this.makeMobileExchangeText(deliveryInfo)}
                  </dl>
                </div>
              </div>
            </div>
            <div class="bx_ct">
              <div class="ct_wrp">
                <button type="button" data-role="toggleButton" class="toggle tit_align_top open">
                  <h4>환불/교환 가능 안내</h4>
                </button>
                <div class="ct slide-ct">
                  <dl class="lst_dfn">
                    <dt>상태별 환불/교환 불가 사유</dt>
                    <dd>
                        <ul>
                            <li>환불/교환 요청 가능 기간이 초과한 경우(배송 완료 시점으로부터 7일 초과 시)</li>
                            <li>재고가 부족한 경우(단순 변심으로 교환을 요청했으나 재고가 부족한 경우 환불처리될 수 있음)</li>
                            <li>주문/제작 상품의 제작이 이미 진행된 경우</li>
                            <li>분실/파손/고장/오염이 발생한 경우</li>
                            <li>모니터 해상도 차이로 인하여 색상 등 이미지가 실제와 상이한 경우</li>
                            <li>뷰티 상품 이용 시 트러블이 발생하는 경우(진료 확인서 및 소견서 등 증빙 시 환불가능. 이 경우, 제반 비용은 고객님께서 부담)</li>
                        </ul>
                    </dd>
                    <dt>상품군별 환불/교환 불가 사유</dt>
                    <dd>
                        <ul>
                            <li>
                                <em>가전/설치상품</em>
                                <span>소비자에게 책임이 있는 사유로 재화 등이 멸실되거나 훼손된 경우 (단, 재화 등의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)</span>
                            </li>
                            <li>
                                <em>의류/잡화/수입명품</em>
                                <span>구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우</span>
                            </li>
                            <li>
                                <em>식품/계절상품/화장품</em>
                                <span>시간의 경과로 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우</span>
                            </li>
                            <li>
                                <em>CD/DVD/GAME/BOOK 등</em>
                                <span>복제가 가능한 상품 등의 포장을 개봉/훼손한 경우</span>
                            </li>
                            <li>
                                <em>네비게이션/OS 등</em>
                                <span>상품의 고유 시리얼 넘버가 훼손/유출되어 내장된 소프트웨어의 가치가 감소한 경우</span>
                            </li>
                            <li>
                                <em>노트북/데스크탑 PC 등</em>
                                <span>홀로그램 등이 분리/분실/훼손되어 상품의 가치가 현저히 감소하여 재판매가 불가할 경우</span>
                            </li>
                            <li>
                                <em>블랙박스/후방카메라/에어컨 등</em>
                                <span>상품을 개봉하여 설치/장착한 경우</span>
                            </li>
                        </ul>
                    </dd>
                  </dl> 
                </div>
              </div>
            </div>
            <div class="bx_ct">
              <div class="ct_wrp">
                <div class="ct">
                  <dl class="lst_dfn">
                    <dt class="blind">판매자와 협의가 불가능한 경우</dt>
                    <dd>
                      <i class="ico_notice"></i>
                      <span>
                        정당한 사유로 반품 요청을 하였으나 판매자와 협의가 되지 않는 경우,
                        <em class="orange">모바일 앱 [마이티몬 &gt; 고객센터] 내 1:1채팅상담</em>으로 문의 해 주십시오.
                      </span>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>`;

    $(`#${this.sWrapper}`).html(sHtml);
  }
}
